import React, { useRef } from "react";
import { MediaField } from "./practiceGuide/components/MediaField";

/**
 * Props:
 * - uploadFn: (e) => void
 * - onMetadata: (name: string, durationSeconds: number) => void
 * - media: {
 *     coverImage: { src?: string },
 *     cardImage: { src?: string },
 *     introVideo: { src?: string }
 *   }
 * - deleteFn: (name: string) => void
 */
export function MediaUpload({ uploadFn, onMetadata, media, deleteFn }) {
  return (
    <>
      {/* Video Thumbnail (coverImage) */}
      <MediaField
        label="Video Thumbnail"
        name="coverImage"
        type="image"
        src={media?.coverImage?.src}
        height={142}
        accept="image/*"
        uploadFn={uploadFn}
        deleteFn={deleteFn}
      />

      {/* Card Image */}
      <MediaField
        label="Card Image"
        name="cardImage"
        type="image"
        src={media?.cardImage?.src}
        height={142}
        accept="image/*"
        uploadFn={uploadFn}
        deleteFn={deleteFn}
      />

      {/* Intro Video */}
      <MediaField
        label="Introduction Video"
        name="introVideo"
        type="video"
        src={media?.introVideo?.src}
        height={320}
        accept="video/*"
        uploadFn={uploadFn}
        deleteFn={deleteFn}
        onMetadata={onMetadata}
      />
    </>
  );
}
